import { render } from "./RiskProfilePage.vue?vue&type=template&id=f7c22566&scoped=true&ts=true"
import script from "./RiskProfilePage.vue?vue&type=script&lang=ts"
export * from "./RiskProfilePage.vue?vue&type=script&lang=ts"

import "./RiskProfilePage.vue?vue&type=style&index=0&id=f7c22566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c22566"]])

export default __exports__